export default __webpack_public_path__ + "static/media/advertiser.c369f07e.svg";